import { Warnung } from "./Symbole";

/*
  Rahmen für alle nicht bedienbaren Bereiche.

  Regel aus dem Lastenheft: Jeder Bereich ist entweder voll funktionsfähig oder
  erkennbar ein Standbild. Nichts dazwischen. Ein Screen, der fertig aussieht
  und beim Klick nichts tut, zerstört im Demo-Termin mehr Vertrauen als ein
  ehrlich statischer. Deshalb das Band oben und `pointer-events: none` auf dem
  Inhalt — hier lässt sich nichts anklicken, und das sieht man.
*/
export default function Standbild({ vorspann, titel, erklaerung, spaeter, children }) {
  return (
    <>
      <div className="detailkopf">
        <p className="detailkopf__vorspann">{vorspann}</p>
        <h1 className="detailkopf__titel">{titel}</h1>
        {erklaerung && (
          <p className="leise" style={{ marginTop: "var(--luft-3)" }}>
            {erklaerung}
          </p>
        )}
      </div>

      <p className="standbild__band">
        <Warnung groesse={18} />
        Standbild — in dieser Demo nicht bedienbar
      </p>

      <div className="standbild__inhalt" aria-hidden="true">
        {children}
      </div>

      {spaeter && (
        <div className="standbild__fuss">
          <strong>Was hier später möglich sein soll:</strong> {spaeter}
        </div>
      )}
    </>
  );
}
